import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import { setChatConversationExpiration } from '../../actions/chat_conversations'
import {
  EXPIRATION_OPTION_5_MINUTES,
  EXPIRATION_OPTION_1_HOUR,
  EXPIRATION_OPTION_6_HOURS,
  EXPIRATION_OPTION_1_DAY,
  EXPIRATION_OPTION_3_DAYS,
  EXPIRATION_OPTION_7_DAYS,
} from '../../constants'
import PopoverLayout from './popover_layout'
import List from '../list'
import Text from '../text'

class ChatConversationExpirationOptionsPopover extends React.PureComponent {

  handleOnSetExpiration = (expiresAt) => {
    this.props.onSetChatConversationExpiration(expiresAt)
    this.handleOnClosePopover()
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { chatConversationId, expiresAtValue, isXS } = this.props

    if (!chatConversationId) return <div/>

    const listItems = [
      {
        hideArrow: true,
        title: 'None',
        onClick: () => this.handleOnSetExpiration(null),
        isActive: !expiresAtValue,
      },
      {
        hideArrow: true,
        title: '5 minutes',
        onClick: () => this.handleOnSetExpiration(EXPIRATION_OPTION_5_MINUTES),
        isActive: expiresAtValue === EXPIRATION_OPTION_5_MINUTES,
      },
      {
        hideArrow: true,
        title: '60 minutes',
        onClick: () => this.handleOnSetExpiration(EXPIRATION_OPTION_1_HOUR),
        isActive: expiresAtValue === EXPIRATION_OPTION_1_HOUR,
      },
      {
        hideArrow: true,
        title: '6 hours',
        onClick: () => this.handleOnSetExpiration(EXPIRATION_OPTION_6_HOURS),
        isActive: expiresAtValue === EXPIRATION_OPTION_6_HOURS,
      },
      {
        hideArrow: true,
        title: '24 hours',
        onClick: () => this.handleOnSetExpiration(EXPIRATION_OPTION_1_DAY),
        isActive: expiresAtValue === EXPIRATION_OPTION_1_DAY,
      },
      {
        hideArrow: true,
        title: '3 days',
        onClick: () => this.handleOnSetExpiration(EXPIRATION_OPTION_3_DAYS),
        isActive: expiresAtValue === EXPIRATION_OPTION_3_DAYS,
      },
      {
        hideArrow: true,
        title: '7 days',
        onClick: () => this.handleOnSetExpiration(EXPIRATION_OPTION_7_DAYS),
        isActive: expiresAtValue === EXPIRATION_OPTION_7_DAYS,
      },
    ]

    return (
      <PopoverLayout
        width={210}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <Text className={[_s.d, _s.px15, _s.py10, _s.bgSecondary].join(' ')}>Chats delete after:</Text>
        <List
          scrollKey='chat_conversation_expiration'
          items={listItems}
          size={isXS ? 'large' : 'small'}
        />
      </PopoverLayout>
    )
  }

}

const mapStateToProps = (state, { chatConversationId }) => ({
  expiresAtValue: state.getIn(['chat_conversations', chatConversationId, 'chat_message_expiration_policy']),
})

const mapDispatchToProps = (dispatch, { chatConversationId }) => ({
  onClosePopover() {
    dispatch(closePopover())
  },
  onSetChatConversationExpiration(expiration) {
    dispatch(setChatConversationExpiration(chatConversationId, expiration))
  },
})

ChatConversationExpirationOptionsPopover.defaultProps = {
  expiresAtValue: PropTypes.string.isRequired,
  isXS: PropTypes.bool,
  onSetChatConversationExpiration: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatConversationExpirationOptionsPopover)